<template>
  <div>
    <sidebar-menu-page-small
      v-show="isPageSmall"
      :downloadUrl="downloadUrl"
      :downloadUrlV2="downloadUrlV2"
      @handleTogglePageSmallMenu="handleTogglePageSmallMenu"
      @doLogout="doLogout"
    />
    <sidebar-menu-page-large
      v-show="!isPageSmall"
      :downloadUrl="downloadUrl"
      :downloadUrlV2="downloadUrlV2"
      @doLogout="doLogout"
      @handleToggleSideMenu="handleToggleSideMenu"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import navbars from '@/common/sidebar-menu'
import SidebarMenuPageSmall from './SidebarMenuPageSmall'
import SidebarMenuPageLarge from './SidebarMenuPageLarge'

export default {
  components: {
    SidebarMenuPageSmall,
    SidebarMenuPageLarge
  },
  data () {
    return {
      navbars: navbars,
      isPageSmall: false,
      downloadUrl: `${process.env.NODE_DOMAIN}/static/dists/pdf/contract.pdf`,
      downloadUrlV2: `https://www.hcube3.com/PDF/personal.pdf`
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    appVersion () {
      return this.userInfo.version
    },
    storageSkipShowRegisterInfoName () {
      return `${this.userInfo.sellerId}-SkipShowRegisterInfo`
    },
    storageSideMenuCloseName () {
      return `${this.userInfo.sellerId}-SideMenuClose`
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    }
  },
  methods: {
    doLogout () {
      $('body').removeClass('show-sidebar')
      let token = localStorage.getItem('tokenSalmon')
      let customHeaders = {}
      if (token) {
        customHeaders = { Authorization: `Bearer ${token}` }
      }
      let logParams = {
        name: eventCode.click_logout_button,
        properties: {}
      }
      EventService.postTrackLog(logParams, customHeaders)

      localStorage.removeItem(this.storageSkipShowRegisterInfoName)
      this.$store.dispatch('doLogout')
      this.$router.push('/login')
    },
    handleToggleSideMenu () {
      const sideMenuSelector = $('.sidebar-menu')
      const menuSelector = $('#menu')
      const wrapperSelector = $('#wrapper')
      const itemMenuSelector = $('.item-menu')
      const iconToggleSideMenuSelector = $('.icon-toggle-side-menu')
      const fixedToggleSideMenuSelector = $('.fixed-toggle-side-menu')
      const tooltipToggleSideMenuSelector = $('.tooltip-toggle-side-menu')

      setTimeout(() => {
        sideMenuSelector.toggleClass('sidebar-menu-close')
        menuSelector.toggleClass('menu-close')
        wrapperSelector.toggleClass('wrapper-side-menu-close')
        itemMenuSelector.children('span').toggleClass('menu-name-hidden')
        iconToggleSideMenuSelector.toggleClass('fa-caret-right')
        fixedToggleSideMenuSelector.toggleClass('fixed-toggle-side-menu-close')

        const isClosedMenu = menuSelector.hasClass('menu-close')
        const tooltipTitle = isClosedMenu ? '開く' : '閉じる'
        localStorage.setItem(this.storageSideMenuCloseName, isClosedMenu)
        tooltipToggleSideMenuSelector.text(tooltipTitle)
      }, 300)
    },
    hanldeSetPageSmall () {
      this.isPageSmall = window.innerWidth < 769
      this.$emit('setSidebarMenuPageSmallMode', $('body').hasClass('show-sidebar'))
    },
    async handleTogglePageSmallMenu (isCloseSubmenu = false) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      await new Promise(resolve => {
        function check () {
          if (window.scrollY === 0) resolve()
          else requestAnimationFrame(check)
        }
        check()
      })
      if (isCloseSubmenu) {
        $('#analysis-submenu').collapse('hide')
      }
      $('body').toggleClass('show-sidebar')
      this.$emit('setSidebarMenuPageSmallMode', $('body').hasClass('show-sidebar'))
    }
  },
  mounted () {
    const menuSelector = $('#menu')
    const isClosedMenu = menuSelector.hasClass('menu-close')
    const tooltipTitle = isClosedMenu ? '開く' : '閉じる'
    const toggleSideMenuSelector = $('.toggle-side-menu')

    toggleSideMenuSelector.hover(function () {
      const tooltipToggleSideMenuSelector = $('.tooltip-toggle-side-menu')
      tooltipToggleSideMenuSelector.text(tooltipTitle)
    })

    this.hanldeSetPageSmall()
    window.addEventListener('resize', this.hanldeSetPageSmall)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.hanldeSetPageSmall)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SidebarMenu.vue